import React, {useEffect, useState} from 'react';

import {NewTagForm} from './NewTagForm';
import {ExistingTagList} from './ExistingTagList';
import {VSpacer} from 'components/Layout/VSpacer';

import {createTag, deleteTag, getTags} from 'api/requests/tagRequests';
import {Tag} from 'api/types/tagTypes';

import i18next from 'i18next';
import {ErrorMessage} from 'components';

export const TagsPageContent: React.FC = () => {
  // Local state
  const [tags, setTags] = useState<Tag[]>();
  const [needTagUpdate, setNeedTagUpdate] = useState(false);
  const [serverErrorMessage, setServerErrorMessage] = useState<string>();

  // Load tags when tags are updated.
  useEffect(() => {
    getTags()
      .then((t: Tag[]) => {
        const sortedTags = t?.sort((a, b) => (a.name < b.name ? -1 : 1));
        setTags(sortedTags);
        setNeedTagUpdate(false);
      })
      .catch(e => console.error(e));
  }, [needTagUpdate]);

  // Handles creation of the tag
  const handleNewTag = async (newName: string) => {
    try {
      await createTag(newName);
      setNeedTagUpdate(true);
    } catch (e) {
      setServerErrorMessage(i18next.t('tagsPage.cannotAdd'));
    }
  };

  // Handles deletion of the tag
  const handleDeleteTag = async (id: string) => {
    try {
      await deleteTag(id);
    } catch (e) {
      setServerErrorMessage(i18next.t('tagsPage.cannotDelete'));
    }
    setNeedTagUpdate(true);
  };

  // Conditionally shown server error message element.
  const ServerMessageElement = () => {
    return (
      <>
        <VSpacer height="1rem" />
        <ErrorMessage>{serverErrorMessage}</ErrorMessage>
      </>
    );
  };

  return (
    <>
      {/* New tag field and button with all validation errors integrated. */}
      <NewTagForm
        tags={tags || []}
        onNewTag={handleNewTag}
        onFocus={() => setServerErrorMessage(undefined)}
      />

      {/* Potential server error responses. */}
      {serverErrorMessage && <ServerMessageElement />}

      <VSpacer height="1rem" />

      {/* List of existing tags. */}
      <div className="overflow-scroll h-full-24">
        <ExistingTagList tags={tags || []} onDelete={handleDeleteTag} />
      </div>
    </>
  );
};
